export default "__VITE_ASSET__C8y16HiY__"